import { render, staticRenderFns } from "./lottie.vue?vue&type=template&id=27acf169&scoped=true&lang=pug&"
import script from "./lottie.vue?vue&type=script&lang=js&"
export * from "./lottie.vue?vue&type=script&lang=js&"
import style0 from "./lottie.vue?vue&type=style&index=0&id=27acf169&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27acf169",
  null
  
)

export default component.exports